import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent as MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';

export interface NavTab {
  label: string;
  path: string;
  contentSrc: string;
}

@Component({
  selector: 'app-sts',
  standalone: false,
  templateUrl: './sts.component.html',
  styleUrls: ['./sts.component.css']
})
export class StsComponent implements OnInit {
  public readonly tabs: NavTab[] = [
    { label: 'Getting Started', path: '/start', contentSrc: '/assets/docs/webconsole/getting-started.md' },
    { label: 'Authentication', path: '/auth', contentSrc: '/assets/docs/webconsole/authentication.md' },
    { label: 'Logs', path: '/logs', contentSrc: '/assets/docs/webconsole/logging.md' },
    { label: 'Key Management', path: '/keymgmt', contentSrc: '/assets/docs/webconsole/keymgmt.md' },
    { label: 'Transfers', path: '/transfers', contentSrc: '/assets/docs/webconsole/transfers.md' }
  ];

  public selectedIndex: number = 0;
  constructor(private router: Router) {}
  ngOnInit(): void {
    const currentPath = this.router.url;
    const initialIndex = this.tabs.findIndex(tab => tab.path === currentPath);
    this.selectedIndex = (initialIndex > -1) ? initialIndex : 0;
  }

  selectedTabChange(event: MatTabChangeEvent): void {
    const selectedTab = this.tabs[event.index];
    if (selectedTab) {
      this.router.navigate([selectedTab.path]);
    }
  }
}
